/**
 * This function adds query parameters to a given URL
 * @param page to navigate to
 * @param params key-value object containing the new query parameters to add
 * @returns a string with the shape "/[url]/?newParam=1&newParam2=34"
 */
import { type QueryParamsType } from '~/shared/contexts';

export const getUrlWithParams = (page: string, params: QueryParamsType = {}): string => {
    // Remove any existing query parameters from the page URL
    const baseUrl = page.split('?')[0] || page;

    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            const paramValue = Array.isArray(value) ? JSON.stringify(value) : value;
            searchParams.set(key, paramValue);
        }
    });

    const searchString = searchParams.toString();

    return searchString ? `${baseUrl}?${searchString}` : baseUrl;
};
